import { useState } from 'react';
import { CategoryChip, ChipsMoreButton, ChipsRow } from './catalogStyles';

const DEFAULT_VISIBLE = 6;

export const CategoryChips = ({ options, selected, onToggle, onClear }) => {
  const [expanded, setExpanded] = useState(false);

  if (options.length === 0) return null;

  const selectedKeys = new Set((selected ?? []).map(String));
  const visibleOptions = expanded ? options : options.slice(0, DEFAULT_VISIBLE);
  const hiddenCount = options.length - visibleOptions.length;

  return (
    <ChipsRow>
      <CategoryChip
        type="button"
        $active={selectedKeys.size === 0}
        onClick={onClear}
      >
        Todos os produtos
      </CategoryChip>
      {visibleOptions.map((option) => (
        <CategoryChip
          key={option.value}
          type="button"
          $active={selectedKeys.has(String(option.value))}
          onClick={() => onToggle(option.value)}
        >
          {option.label}
        </CategoryChip>
      ))}
      {hiddenCount > 0 && (
        <ChipsMoreButton type="button" onClick={() => setExpanded(true)}>
          + Ver mais
        </ChipsMoreButton>
      )}
      {expanded && options.length > DEFAULT_VISIBLE && (
        <ChipsMoreButton type="button" onClick={() => setExpanded(false)}>
          Ver menos
        </ChipsMoreButton>
      )}
    </ChipsRow>
  );
};
